import { pl } from 'date-fns/locale';
import { Label } from '@ooh/ui/components/label';
import { DateRangeButtonField } from '@ooh/ui/components/date-range-button-field';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@ooh/ui/components/table';

export interface PeriodLabelMapping {
  /** Distinct raw free-text value found in the period-description column. */
  label: string;
  from: string;
  to: string;
}

export interface PeriodLabelMappingTableLabels {
  sectionLabel: string;
  valueColumnLabel: string;
  dateRangeColumnLabel: string;
  dateRangePlaceholder?: string;
}

export interface PeriodLabelMappingTableProps {
  mappings: PeriodLabelMapping[];
  onUpdate: (label: string, field: 'from' | 'to', value: string) => void;
  labels: PeriodLabelMappingTableLabels;
  testIdPrefix?: string;
}

/**
 * Maps each distinct free-text period phrase found in a "opis okresu" column
 * (e.g. "cały czerwiec", "pierwsza połowa lipca") to an explicit date range,
 * since these files carry no machine-parseable dates at all.
 */
export function PeriodLabelMappingTable({
  mappings,
  onUpdate,
  labels,
  testIdPrefix = 'period-label-mapping',
}: PeriodLabelMappingTableProps) {
  return (
    <div className="space-y-1.5">
      <Label required>{labels.sectionLabel}</Label>
      <div className="overflow-x-auto rounded-md border border-border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{labels.valueColumnLabel}</TableHead>
              <TableHead>{labels.dateRangeColumnLabel}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mappings.map((m, idx) => (
              <TableRow key={m.label} listRow>
                <TableCell className="px-4 py-2 text-[13px]">{m.label}</TableCell>
                <TableCell className="px-4 py-2">
                  <DateRangeButtonField
                    fromValue={m.from}
                    toValue={m.to}
                    onChange={({ from, to }) => {
                      onUpdate(m.label, 'from', from);
                      onUpdate(m.label, 'to', to);
                    }}
                    placeholder={labels.dateRangePlaceholder}
                    locale={pl}
                    testId={`${testIdPrefix}-range-${idx}`}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
